import { useState as O, useEffect as M, useRef as p } from "react";
var l = {}, k = {}, y = {}, j = {};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
j.parse = V;
j.serialize = q;
var L = Object.prototype.toString, R = Object.prototype.hasOwnProperty, F = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/, N = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/, B = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, H = /^[\u0020-\u003A\u003D-\u007E]*$/;
function V(e, t) {
  if (typeof e != "string")
    throw new TypeError("argument str must be a string");
  var r = {}, o = e.length;
  if (o < 2) return r;
  var i = t && t.decode || J, n = 0, a = 0, s = 0;
  do {
    if (a = e.indexOf("=", n), a === -1) break;
    if (s = e.indexOf(";", n), s === -1)
      s = o;
    else if (a > s) {
      n = e.lastIndexOf(";", a - 1) + 1;
      continue;
    }
    var u = C(e, n, a), c = $(e, a, u), v = e.slice(u, c);
    if (!R.call(r, v)) {
      var f = C(e, a + 1, s), h = $(e, s, f);
      e.charCodeAt(f) === 34 && e.charCodeAt(h - 1) === 34 && (f++, h--);
      var g = e.slice(f, h);
      r[v] = Z(g, i);
    }
    n = s + 1;
  } while (n < o);
  return r;
}
function C(e, t, r) {
  do {
    var o = e.charCodeAt(t);
    if (o !== 32 && o !== 9) return t;
  } while (++t < r);
  return r;
}
function $(e, t, r) {
  for (; t > r; ) {
    var o = e.charCodeAt(--t);
    if (o !== 32 && o !== 9) return t + 1;
  }
  return r;
}
function q(e, t, r) {
  var o = r && r.encode || encodeURIComponent;
  if (typeof o != "function")
    throw new TypeError("option encode is invalid");
  if (!F.test(e))
    throw new TypeError("argument name is invalid");
  var i = o(t);
  if (!N.test(i))
    throw new TypeError("argument val is invalid");
  var n = e + "=" + i;
  if (!r) return n;
  if (r.maxAge != null) {
    var a = Math.floor(r.maxAge);
    if (!isFinite(a))
      throw new TypeError("option maxAge is invalid");
    n += "; Max-Age=" + a;
  }
  if (r.domain) {
    if (!B.test(r.domain))
      throw new TypeError("option domain is invalid");
    n += "; Domain=" + r.domain;
  }
  if (r.path) {
    if (!H.test(r.path))
      throw new TypeError("option path is invalid");
    n += "; Path=" + r.path;
  }
  if (r.expires) {
    var s = r.expires;
    if (!G(s) || isNaN(s.valueOf()))
      throw new TypeError("option expires is invalid");
    n += "; Expires=" + s.toUTCString();
  }
  if (r.httpOnly && (n += "; HttpOnly"), r.secure && (n += "; Secure"), r.partitioned && (n += "; Partitioned"), r.priority) {
    var u = typeof r.priority == "string" ? r.priority.toLowerCase() : r.priority;
    switch (u) {
      case "low":
        n += "; Priority=Low";
        break;
      case "medium":
        n += "; Priority=Medium";
        break;
      case "high":
        n += "; Priority=High";
        break;
      default:
        throw new TypeError("option priority is invalid");
    }
  }
  if (r.sameSite) {
    var c = typeof r.sameSite == "string" ? r.sameSite.toLowerCase() : r.sameSite;
    switch (c) {
      case !0:
        n += "; SameSite=Strict";
        break;
      case "lax":
        n += "; SameSite=Lax";
        break;
      case "strict":
        n += "; SameSite=Strict";
        break;
      case "none":
        n += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return n;
}
function J(e) {
  return e.indexOf("%") !== -1 ? decodeURIComponent(e) : e;
}
function G(e) {
  return L.call(e) === "[object Date]";
}
function Z(e, t) {
  try {
    return t(e);
  } catch {
    return e;
  }
}
Object.defineProperty(y, "__esModule", {
  value: !0
});
var Q = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var o = 0; o < r.length; o++) {
      var i = r[o];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, r, o) {
    return r && e(t.prototype, r), o && e(t, o), t;
  };
}();
y.hasCookies = Y;
var W = j, S = X(W);
function X(e) {
  return e && e.__esModule ? e : { default: e };
}
function K(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var d = "lS_", z = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    K(this, e), this.cookieOptions = Object.assign({ path: "/" }, t), d = t.prefix === void 0 ? d : t.prefix;
  }
  return Q(e, [{
    key: "getItem",
    value: function(r) {
      var o = S.default.parse(document.cookie);
      return !o || !o.hasOwnProperty(d + r) ? null : o[d + r];
    }
  }, {
    key: "setItem",
    value: function(r, o) {
      return document.cookie = S.default.serialize(d + r, o, this.cookieOptions), o;
    }
  }, {
    key: "removeItem",
    value: function(r) {
      var o = Object.assign({}, this.cookieOptions, { maxAge: -1 });
      return document.cookie = S.default.serialize(d + r, "", o), null;
    }
  }, {
    key: "clear",
    value: function() {
      var r = S.default.parse(document.cookie);
      for (var o in r)
        o.indexOf(d) === 0 && this.removeItem(o.substr(d.length));
      return null;
    }
  }]), e;
}();
y.default = z;
function Y() {
  var e = new z();
  try {
    var t = "__test";
    e.setItem(t, "1");
    var r = e.getItem(t);
    return e.removeItem(t), r === "1";
  } catch {
    return !1;
  }
}
Object.defineProperty(k, "__esModule", {
  value: !0
});
k.default = te;
var ee = y, E = "__test";
function P(e) {
  try {
    var t = window[e];
    return t.setItem(E, "1"), t.removeItem(E), !0;
  } catch {
    return !1;
  }
}
function te() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "localStorage", t = String(e).replace(/storage$/i, "").toLowerCase();
  if (t === "local")
    return P("localStorage");
  if (t === "session")
    return P("sessionStorage");
  if (t === "cookie")
    return (0, ee.hasCookies)();
  if (t === "memory")
    return !0;
  throw new Error("Storage method `" + e + "` is not available.\n    Please use one of the following: localStorage, sessionStorage, cookieStorage, memoryStorage.");
}
var I = {};
Object.defineProperty(I, "__esModule", {
  value: !0
});
var re = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var o = 0; o < r.length; o++) {
      var i = r[o];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, r, o) {
    return r && e(t.prototype, r), o && e(t, o), t;
  };
}();
function oe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var ne = function() {
  function e() {
    oe(this, e), this._data = {};
  }
  return re(e, [{
    key: "getItem",
    value: function(r) {
      return this._data.hasOwnProperty(r) ? this._data[r] : null;
    }
  }, {
    key: "setItem",
    value: function(r, o) {
      return this._data[r] = String(o);
    }
  }, {
    key: "removeItem",
    value: function(r) {
      return delete this._data[r];
    }
  }, {
    key: "clear",
    value: function() {
      return this._data = {};
    }
  }]), e;
}();
I.default = ne;
Object.defineProperty(l, "__esModule", {
  value: !0
});
l.MemoryStorage = l.CookieStorage = l.isSupported = l.storage = void 0;
var ie = k, b = x(ie), ae = y, T = x(ae), se = I, A = x(se);
function x(e) {
  return e && e.__esModule ? e : { default: e };
}
var m = null;
(0, b.default)("localStorage") ? l.storage = m = window.localStorage : (0, b.default)("sessionStorage") ? l.storage = m = window.sessionStorage : (0, b.default)("cookieStorage") ? l.storage = m = new T.default() : l.storage = m = new A.default();
var le = l.default = m;
l.storage = m;
l.isSupported = b.default;
l.CookieStorage = T.default;
l.MemoryStorage = A.default;
class U {
  constructor(t = "global") {
    this.group = t, this.localStorage = le;
  }
  /**
   * Sets the group under which to save a value.
   *
   * E.g. as a group of "global" and a key of "thing", the location
   * in storage would be "global.thing"
   *
   * @param group Unique key to group under
   */
  setGroup(t) {
    this.group = t;
  }
  /**
   * @returns Currently set group name
   */
  getGroup() {
    return this.group;
  }
  /**
   * Returns a value stored in storage
   *
   * @param key The key under the group "group.key"
   * @returns String value saved under "group.key"
   */
  getItem(t) {
    return this.localStorage.getItem(`${this.group}.${t}`);
  }
  /**
   * Saves a new value in storage
   *
   * @param key The key under the group "group.key"
   * @param value String value to save
   */
  setItem(t, r) {
    this.localStorage.setItem(`${this.group}.${t}`, r);
  }
  /**
   * Removes a stored value
   *
   * @param key The key under the group "group.key"
   */
  removeItem(t) {
    this.localStorage.removeItem(`${this.group}.${t}`);
  }
}
class ue {
  constructor() {
    this.storageLocation = "suggestion_history", this.history = [], this.storage = new U("commute");
    const t = this.storage.getItem(this.storageLocation);
    t && (this.history = JSON.parse(t));
  }
  /**
   * Pushes the new suggestion to the top of the array. If it's a
   * duplicate (based on the locationId), it will remove the duplicate(s)
   *
   * @param suggestion Address suggestion object including locationId and address object
   */
  push(t) {
    this.history = this.removeDuplicateEntries(t), this.history.unshift(t), this.history.length > 5 && (this.history = this.history.slice(0, 5)), this.storage.setItem(this.storageLocation, JSON.stringify(this.history));
  }
  /**
   * Indicates whether there are suggestions saved in history
   *
   * @returns boolean
   */
  hasSuggestionHistory() {
    return this.history.length > 0;
  }
  /**
   * Returns the array of address suggestions from local storage
   *
   * @returns Array of address suggestions (only locationId and address object)
   */
  getSuggestionHistory() {
    return this.history;
  }
  removeDuplicateEntries(t) {
    return this.history.filter((r) => r.locationId !== t.locationId);
  }
}
const ce = new ue(), fe = ({
  data: e,
  fileName: t,
  fileType: r
}) => {
  const o = `text/${r}`, i = new Blob([e], { type: o }), n = document.createElement("a");
  n.download = `${t}.${r}`, n.href = window.URL.createObjectURL(i);
  const a = new MouseEvent("click", {
    view: window,
    bubbles: !0,
    cancelable: !0
  });
  n.dispatchEvent(a), n.remove();
}, de = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  downloadFile: fe
}, Symbol.toStringTag, { value: "Module" })), Ee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BrowserStorage: U,
  commuteHistory: ce,
  file: de
}, Symbol.toStringTag, { value: "Module" })), ge = (e, t) => {
  const [r, o] = O(e);
  return M(
    () => {
      const i = setTimeout(() => {
        o(e);
      }, t);
      return () => {
        clearTimeout(i);
      };
    },
    [e, t]
    // Only re-call effect if value or delay changes
  ), r;
}, he = (e) => {
  const t = p(e), r = p(), o = p(!1), i = p(!1), [, n] = O(0);
  o.current && (i.current = !0), M(() => (o.current || (r.current = t.current(), o.current = !0), n((a) => a + 1), () => {
    i.current && r.current && r.current();
  }), []);
}, me = () => {
  const [e, t] = O(!0);
  return M(() => {
    t(!1);
  }, []), e;
}, Pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useDebounce: ge,
  useEffectOnce: he,
  useIsSSR: me
}, Symbol.toStringTag, { value: "Module" })), ve = "0123456789bcdefghjkmnpqrstuvwxyz";
function ye(e) {
  if (!(e != null && e.length))
    throw new Error("Invalid geohash");
  const t = e.toLowerCase();
  let r = !0, o = -90, i = 90, n = -180, a = 180;
  for (let u = 0; u < t.length; u++) {
    const c = t.charAt(u), v = ve.indexOf(c);
    if (v === -1)
      throw new Error("Invalid geohash");
    for (let f = 4; f >= 0; f--) {
      const h = v >> f & 1;
      if (r) {
        const g = (n + a) / 2;
        h === 1 ? n = g : a = g;
      } else {
        const g = (o + i) / 2;
        h === 1 ? o = g : i = g;
      }
      r = !r;
    }
  }
  return {
    sw: { lat: o, lng: n },
    ne: { lat: i, lng: a }
  };
}
function D(e) {
  const t = ye(e), r = t.sw.lat, o = t.sw.lng, i = t.ne.lat, n = t.ne.lng;
  let a = (r + i) / 2, s = (o + n) / 2;
  return a = Number(a.toFixed(Math.floor(2 - Math.log(i - r) / Math.LN10))), s = Number(s.toFixed(Math.floor(2 - Math.log(n - o) / Math.LN10))), { lat: a, lng: s };
}
function pe(e) {
  const t = e.split("_");
  if (t.length < 2)
    throw new Error("Invalid geogId");
  return D(t[1]);
}
function Se(e = []) {
  const t = (i) => Object.values(i).map((n) => Array.isArray(n[0]) ? t(n) : [n[1], n[0]]);
  return {
    type: "FeatureCollection",
    features: [
      {
        id: "schoolCatchment",
        type: "Feature",
        geometry: {
          type: "MultiPolygon",
          coordinates: t(e)
        }
      }
    ]
  };
}
function be(e) {
  return {
    type: "FeatureCollection",
    features: [
      {
        id: "route",
        type: "Feature",
        geometry: e
      }
    ]
  };
}
const ze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decodeGeogId: pe,
  decodeGeohash: D,
  formatGeometry: Se,
  formatMapBoxGeoJson: be
}, Symbol.toStringTag, { value: "Module" })), _e = (e, t = "en-US", r = "USD", o = 0) => new Intl.NumberFormat(t, { style: "currency", currency: r, maximumFractionDigits: o }).format(
  e ?? 0
), we = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCurrency: _e
}, Symbol.toStringTag, { value: "Module" })), _ = (e) => typeof e == "object" && e !== null && !Array.isArray(e);
function w(e, ...t) {
  if (!t.length) return e;
  const r = t.shift();
  return _(e) && _(r) && Object.keys(r).forEach((o) => {
    _(r[o]) ? (e[o] || Object.assign(e, { [o]: {} }), w(e[o], r[o])) : Object.assign(e, { [o]: r[o] });
  }), w(e, ...t);
}
const Oe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isObject: _,
  mergeDeep: w
}, Symbol.toStringTag, { value: "Module" })), Me = (e, t, r) => t === 1 ? e : r ?? `${e}s`, ke = (e) => e.charAt(0).toUpperCase() + e.slice(1), je = ({
  houseNumber: e,
  street: t,
  city: r,
  state: o,
  country: i,
  postalCode: n,
  description: a
}) => [`${e ? `${e && t ? `${e} ` : `${e}`}` : ""}${t || ""}`, r, o, i, n].reduceRight((u, c) => u && c ? `${c}, ${u}` : c || u || "") || "", Ie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: ke,
  formatAddress: je,
  pluralize: Me
}, Symbol.toStringTag, { value: "Module" })), Te = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  number: we,
  object: Oe,
  string: Ie
}, Symbol.toStringTag, { value: "Module" })), xe = (e, t) => t === "school", Ce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isSchool: xe
}, Symbol.toStringTag, { value: "Module" })), Ae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  poi: Ce
}, Symbol.toStringTag, { value: "Module" }));
export {
  Ee as browserUtils,
  Pe as hookUtils,
  ze as mapUtils,
  Te as primitiveUtils,
  Ae as typeguardUtils
};
